export default __webpack_public_path__ + "static/media/modal-confirm-tick.70595752.svg";